module.exports = __webpack_public_path__ + "static/EteTechnology_LOGO_YATAY-73693b92ed1a53efbc8efe488af68689.png";